module.exports = __webpack_public_path__ + "media/images/img_youtube-dd861038103e95bd0098cf8484bf0cb4.png";